module.exports = __webpack_public_path__ + "img/transfer_mode2.f7e36df2.png";